module.exports = __webpack_public_path__ + "static/img/店铺_10.c35e659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/images/店铺_10.jpg
// module id = ZN5J
// module chunks = 1